import { modalTitleTranslationKey, moduleName } from '~/modules/debt-sold/config';

export default ({ store, app }) => {
  store.registerModule(moduleName, {
    namespaced: true,
    state: () => ({ isModalOpen: false }),
    mutations: {
      toggle(state, value) {
        state.isModalOpen = value;
      },
    },
    getters: {
      tag(...[, , { auth }]) {
        return auth.user && auth.user.transferTag;
      },
      messagesByLocale() {
        return app.i18n.messages[app.i18n.locale][moduleName];
      },
      translationTag(...[, getters]) {
        return getters.messagesByLocale[getters.tag];
      },
      modalTitle(...[, getters]) {
        return getters.messagesByLocale[modalTitleTranslationKey];
      },
    },
  });
};
